import { apiCall } from "@/common/api/ApiResult.model";
import {
  InformationSensitivityType,
  SensitivityLevelHelper,
} from "@/common/models";
import axios from "axios";
import {
  CreateLabelForAnalysisRequest,
  CustomLabelAnalysis,
  LabelTeachStatus,
  LabelForAnalysisRequest,
} from "./model";
import { SharedState } from "@/common/state";
export const change_label_sensitivity = apiCall<
  Array<{
    id: string;
    sensitivity: number;
    sensitivityType: InformationSensitivityType;
  }>,
  number
>("update-label-sensitivity", async (labels) => {
  await axios.patch("/label-api/", labels);
  return {
    success: true,
    value: 200,
  };
});

export const create_new_content_label = apiCall<
  {
    name: string;
    desc: string;
    sensitivity: number;
    sensitivityType: string;
    infoTypeCategoryId: string;
    code: number;
  },
  string
>(
  "content-labels.create",
  async ({
    sensitivity,
    sensitivityType,
    infoTypeCategoryId,
    code,
    name,
    desc,
  }) => {
    const res = await axios.post(`/label-api`, {
      labelName: name,
      description: desc,
      sensitivityType,
      sensitivity: SensitivityLevelHelper.intToFloat(sensitivity),
      labelType: "Content_label",
      labelCategory: "Content",
      abstracts: [infoTypeCategoryId],
      generation: 1,
      concrete: 0.8,
      infoTypeCategoryId,
      code,
    });

    return {
      success: true,
      value: res.data.id,
    };
  }
);

export const update_label_texts = apiCall<
  {
    id: string;
    labelName: string;
    description: string;
  },
  boolean
>("content-labels.update-texts", async (label) => {
  await axios.patch(`/label-api`, [label]);
  return {
    success: true,
    value: true,
  };
});

export const send_new_label_for_analysis = apiCall<
  CreateLabelForAnalysisRequest,
  CustomLabelAnalysis
>(
  "custom-labels.analysis",
  async (data) => {
    const formData = new FormData();

    Object.entries(data).forEach(([key, value]) => {
      if (key === "files") {
        for (let i = 0; i < value.length; i++) {
          formData.append("files", value[i]);
        }
      }
      // @ts-ignore
      formData.append(key, value);
    });
    const res = await axios({
      method: "POST",
      baseURL: "https://reasoning.cognni.ai/api",
      url: "/analyzeFile",
      headers: {
        "Content-Type": "multipart/form-data",
        authorization: SharedState.loggedUser.value.authorization,
      },
      data: formData,
    });

    return {
      success: true,
      value: res.data,
    };
  }
  /*  {
    force_mock() {
      return true;
    },
  } */
);

/* 
docs : https://dev.azure.com/shieldox/Connectors/_git/integrations-manager?path=%2Fdocumentation%2Fteach.md&_a=preview
response
{
  "ok": true | false,
  "value": "new",
   "error": {"code": "...", "msg":""}
}
*/

export const send_created_label_for_analysis = apiCall<
  LabelForAnalysisRequest,
  boolean
>(
  "custom-labels.send-created-label-to-teach",
  async (payload) => {
    await axios.post("/extproxy/integrations/teach-custom-label", payload);
    return {
      success: true,
      value: true,
    };
  }
  /*  {
    force_mock() {
      return true;
    },
  } */
);

export const send_folder_path_to_analysis = apiCall<
  string,
  { ok: true; count: number } | { ok: false; reason: string }
>(
  "label-teach.folder-path-analysis",
  async (folder_path) => {
    const res = await axios.get(
      `/extproxy/integrations/teach-config-item-analysis?id=${folder_path}`
    );
    return {
      success: true,
      value: res.data.error
        ? { ok: false, reason: res.data.error?.msg }
        : { ok: true, count: res.data.value.expectedFileCount },
    };
  }
  /* {
    force_mock() {
      return true;
    },
  } */
);

export const send_folders_for_label_teach = apiCall<
  { label_id: string; folders: string[] },
  boolean
>(
  "label-teach.send-folder-paths",
  async ({ folders, label_id }) => {
    await axios.put(
      "/extproxy/integrations/teach-config-items?isSyncable=true",
      {
        ids: folders,
        labelId: label_id,
      }
    );
    return {
      success: true,
      value: true,
    };
  }
  /* {
    force_mock() {
      return true;
    },
  } */
);

export const delete_custom_label = apiCall<string, boolean>(
  "custom-labels.remove",
  async (label_id) => {
    await axios({
      method: "POST",
      baseURL: "https://reasoning.cognni.ai/api",
      url: "/removeLabel",
      data: {
        labelId: label_id,
      },
    });
    return {
      success: true,
      value: true,
    };
  }
);

export const get_label_teach_status = apiCall<string, LabelTeachStatus>(
  "label-teach.label-analysis-status",
  async (label_id) => {
    const res = await axios.get(
      `/extproxy/integrations/teach-custom-labels?labelId=${label_id}`
    );
    let result: LabelTeachStatus = {
      created_at: "",
      label_status: "new",
      folders: [],
      is_running: false,
    };
    if (res.data.ok) {
      const is_not_running =
        !res.data.value.status ||
        res.data.value.status === "achieved" ||
        res.data.value.teachConfigItems.length == 0;
      result = {
        created_at: "",
        label_status: res.data.value.status,
        is_running: !is_not_running,
        folders: res.data.value.teachConfigItems
          ? res.data.value.teachConfigItems.map((item: any) => {
              return {
                path: item.id,
                is_running: item.status == "processing",
                num_of_files: item.fileCount,
              };
            })
          : [],
      };
    }
    return {
      success: true,
      value: result,
    };
  }
  /* {
    force_mock() {
      return true;
    },
  } */
);

/* export const get_label_teach_status = apiCall<string, LabelTeachStatus>(
  "label-teach.label-analysis-status",
  async (label_id) => {
    const res = await axios({
      method: "POST",
      baseURL: "https://reasoning.cognni.ai/api",
      url: "/getLabelStatus",
      headers: {
        authorization: "Bearer 1rwcbeb-try-314f-b1da-bc1215b4fc51", //SharedState.loggedUser.value.authorization,
      },
      data: {
        labelId: label_id,
      },
    });
    let result: LabelTeachStatus = {
      created_at: "",
      folders: [],
      is_running: false,
    };
    if (res.data.ok) {
      const is_not_running =
        !res.data.value.status ||
        res.data.value.status === "achieved" ||
        res.data.value.teachConfigItems.length == 0;
      result = {
        created_at: "",
        is_running: !is_not_running,
        folders: res.data.value.teachConfigItems
          ? res.data.value.teachConfigItems.map((item: any) => {
              return {
                path: item.id,
                is_running: item.status == "processed",
                num_of_files: item.fileCount,
              };
            })
          : [],
      };
    }
    return {
      success: true,
      value: result,
    };
  }
); */
